import { Select, Option, Label } from "@twilio-paste/core";

import { Field } from "../../store/definitions";

type DropDownProps = {
    field: Field;
    onChange?: (newValue: string) => void;
    value?: string;
};

export const DropDown = ({ field, onChange, value }: DropDownProps) => {
    const { name, label, placeholder, required, options } = field;

    const getPlaceholder = (placeholderValue: string | undefined) => {
        if (!placeholderValue) {
            return undefined;
        }

        return (
            <Option value="" disabled hidden>
                {placeholderValue}
            </Option>
        );
    };

    const getOptions = (dropdownOptions: Record<string, string> | undefined) => {
        const entries = Object.entries(dropdownOptions || {});

        return entries.map(([key, optionLabel]) => (
            <Option key={key} value={key}>
                {optionLabel}
            </Option>
        ));
    };

    return (
        <>
            <Label htmlFor={name}>{label}</Label>
            <Select
                id={name}
                name={name}
                value={value ?? ""}
                onChange={(e) => onChange?.(e.target.value)}
                required={required}
            >
                {getPlaceholder(placeholder)}
                {getOptions(options)}
            </Select>
        </>
    );
};
